import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import { handleRedirectOnCondition, useGlobalQueries } from '@/exceed';

import { urlSearch } from '@/search';

import getAxiosConfig from '../helpers/getAxiosConfig';
import getVideosPropertiesTransform from '../helpers/getVideosPropertiesTransform';
import handleAdminVideoAxiosError from '../helpers/handleAdminVideoAxiosError';

export default ({ isEnabled = true } = {}) => {
  const { adminSettings } = useGlobalQueries();
  const { orgId, id: videoId, type } = useParams();
  const isInLiveMode = type === 'live';
  const versionId = urlSearch.getValue('version_id');

  const videoPropertiesKey = useMemo(
    () => ['videoProperties', type, videoId, versionId],
    [type, versionId, videoId],
  );

  const videoProperties = useQuery(
    videoPropertiesKey,
    async () => {
      try {
        const { data } = await axios(
          getAxiosConfig('get-video-properties', { isInLiveMode, videoId, versionId }),
        );

        return data;
      } catch (error) {
        const redirectUrl = `/videos/organizations/${orgId}/${type}/unauthorized`;

        const isForbidden = error.response?.status === 403;

        handleRedirectOnCondition({ isForbidden, redirectUrl });
        if (!isForbidden) handleAdminVideoAxiosError(error);
        return {};
      }
    },
    {
      enabled: isEnabled,
      select: (data) =>
        getVideosPropertiesTransform({
          adminSettings,
          data,
          type,
        }),
    },
  );

  return { videoProperties, videoPropertiesKey };
};
